<script lang="ts">
  export let searchTerm;
  export let title;
  export let id;
  export let ariaLabel = "";
</script>

<!-- filter for search option lists -->
<div id="filterInput" class="pt-2">
  <input
    type="text"
    {title}
    id="filter-{id}"
    name="filter"
    class="form-control"
    placeholder="Type to filter"
    autocomplete="off"
    aria-label={ariaLabel || title}
    bind:value={searchTerm}
    on:input
  />
</div>
